"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var hintOnPath_1 = require("../hints/hintOnPath");

var hintOnWord_1 = require("../hints/hintOnWord");

var LanguageHints_1 = require("./LanguageHints");

var LanguageState_1 = require("./LanguageState");

var LanguageMode =
/** @class */
function () {
  function LanguageMode(name) {
    this.hints = null;
    this.name = name;
    this.states = [];
  }

  LanguageMode.create = function (name) {
    return new LanguageMode(name);
  };

  LanguageMode.prototype.addDefaultHints = function (options) {
    return this.addHints('on-word', options);
  };

  LanguageMode.prototype.addDefaultState = function (cb) {
    return this.addState('start', cb);
  };

  LanguageMode.prototype.addHints = function (type, options) {
    switch (type) {
      case 'on-path':
        this.hints = new LanguageHints_1.LanguageHints(hintOnPath_1.hintOnPath, options);
        break;

      case 'on-word':
        this.hints = new LanguageHints_1.LanguageHints(hintOnWord_1.hintOnWord, options);
        break;
    }

    return this;
  };

  LanguageMode.prototype.addState = function (name, cb) {
    var state = LanguageState_1.LanguageState.create(name);
    cb(state);
    this.states.push(state);
    return this;
  };

  LanguageMode.prototype.getHints = function () {
    return this.hints ? this.hints.getStrategy() : null;
  };

  LanguageMode.prototype.getLanguageMode = function () {
    return this.states.reduce(function (prev, curr) {
      var stateName = curr.getName();
      var stateRules = curr.getRuleList();
      prev[stateName] = stateRules;
      return prev;
    }, {});
  };

  LanguageMode.prototype.getName = function () {
    return this.name;
  };

  return LanguageMode;
}();

exports.LanguageMode = LanguageMode;